import React from 'react';
import PropTypes from 'prop-types';
import {Modal} from 'react-bootstrap';

const UploadTutorial = ({hide}) => {
	return (
		<div className='upload-tutorial-container'>
			<Modal.Header>
				Upload Clients Tutorial
			</Modal.Header>
			<Modal.Body>
				<div className='row'>
					<div className='col-md-12'>
						<p>Begin by creating a table in a spreadsheet using Excel, Numbers, or some similar
							software. Be sure to format the spread sheet exactly like the image below. If the
							header values are stacked vertically on the side rather than horizontally accross
							the top, an error will occur an the upload will be terminated.
						</p>
					</div>
				</div>
				<div className='row'>
					<img
						src='assets/images/upload_tutorial.png'
						className='upload-tutorial-excel-img'
					/>
				</div>
				<div className='row'>
					<ul>
						<hr className='dotted short' />
						<div className='col-md-12'>
							<li>
								<p><strong>Manditory Fields </strong>must have a header in the file. Even if the field
									is left blank, the header must exist. For example, if you don't know a clients
									email address, you can leave that field blank in the row with the clients information,
									but the header <strong>Email </strong> must still be in the file.
								</p>
							</li>
							<li>
								<p><strong>Optional Fields </strong> Do not need to be in the file. If an optional field is
									created and the field is left blank for a client, it will just appear as an empty
									input field on that clients page.
								</p>
							</li>
							<li>
								<p><strong>Custom Fields </strong> can be whatever you want them to be, and you may use
									as many as you would like. Just like with manditory and optional fields, if any fields
									are left blank for a client, they will appear as empty input fields on the clients page.
								</p>
							</li>
						</div>
					</ul>
				</div>
				<hr className='dotted short' />
				<div className='row'>
					<div className='col-md-6 col-xs-12'>
						<img
							src='assets/images/upload_tutorial_2.png'
							className='upload-tutorial-menu-img'
						/>
					</div>
				</div>
				<div className='row'>
					<div className='col-md-12'>
						<p>Once you're finished creating you're spread sheet, export the file to CSV and upload your clients.</p>
						<p><i>* NOTE *</i> Files must be exported using Unicode (UTF-8)</p>
					</div>
				</div>
				<hr className='dotted short' />
				<div
					className='btn btn-default'
					onClick={hide}
					>
					Got It!
				</div>
			</Modal.Body>
		</div>
		)
}

export default UploadTutorial;



// WEBPACK FOOTER //
// ./src/browser/components/clients/upload-tutorial.js